// Single source of truth for finance audit-action → treasurer-copy labels.
// Previously duplicated verbatim in AuditLogPanel.tsx + AuditLogPage.tsx (a
// "never duplicate the mapping" Golden Rule violation); EFR-002 hoisted it here
// so the two surfaces stay identical by construction.
//
// Persisted audit-action strings are append-only forensic history — never
// rewrite a value. The action string is `Void` (render-boundary label is the
// same word; LedgerStatus.Voided is the money-row sense), and
// `BankTransactionExcludedFromReport` is the ADR-014 exclude constant (must
// byte-match `FinanceAuditActions.ExcludeFromReport`). The legacy
// `Dismiss`/`BankTransactionCategorized`/`ClassifyAsTransfer` strings stay
// readable for pre-collapse rows.
export const AUDIT_ACTION_LABELS: Record<string, string> = {
  Create: 'Created',
  Update: 'Updated',
  Delete: 'Deleted',
  Classify: 'Classified',
  Dismiss: 'Dismissed',
  Refund: 'Refunded',
  Reattribute: 'Reattributed',
  Redesignate: 'Redesignated',
  File: 'Filed',
  Amend: 'Amended',
  CreateContact: 'Created contact',
  UpdateContact: 'Updated contact',
  CreateContribution: 'Created contribution',
  UpdateContribution: 'Updated contribution',
  CreateProfile: 'Updated profile',
  UpdateProfile: 'Updated profile',
  DeleteProfile: 'Deleted profile',
  // ADR-014 / EFR-002.
  Void: 'Void',
  BankTransactionExcludedFromReport: 'Excluded from report',
  BankTransactionCategorized: 'Marked as transfer',
  ClassifyAsTransfer: 'Paired as transfer',
  // ADR-004 — a contact merge kept the survivor's OrganizationType over a
  // conflicting loser value; the treasurer verifies it on the survivor contact.
  ContactMergeOrganizationTypeConflict: 'Merge: organization type conflict',
  // Issue #350 — the treasurer resolved / dismissed that merge conflict from the
  // inline fix-it alert (resolve sets the chosen subtype; dismiss keeps the survivor's).
  ContactMergeOrganizationTypeConflictResolved: 'Merge conflict resolved',
  ContactMergeOrganizationTypeConflictDismissed: 'Merge conflict dismissed',
};

export function getActionLabel(action: string): string {
  return AUDIT_ACTION_LABELS[action] || action;
}
